"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalRenewalMTADeclineTextOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../commonFunctions");
var WolfMotorMTADeclineText_1 = require("../declineTextOutputWidget/WolfMotorMTADeclineText");
var react_router_dom_1 = require("react-router-dom");
var SupportPortalRenewalMTADeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(SupportPortalRenewalMTADeclineTextOutputWidget, _super);
    function SupportPortalRenewalMTADeclineTextOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.underwritingResultArray = _this.props.engine.getInteraction().underwritingResult;
        _this.inRenewalWindow = _this.props.engine.getInteraction().uistate.renewalWindow;
        _this.renderWording = function (underwritingRule) {
            var declineText = new WolfMotorMTADeclineText_1.WolfMotorMTADeclineText(_this.props);
            var journeyState = _this.props.engine.getJourneyState();
            var mtaHardDecline = journeyState.mtaHardDecline;
            var matchingRules = declineText.underwritingResultCustomerWordings.filter(function (uw) { return uw.key === underwritingRule; });
            if (matchingRules.length) {
                var selectedUw = void 0;
                if (matchingRules.length > 1) {
                    selectedUw = matchingRules.find(function (uw) { return uw.declineType === (mtaHardDecline ? "hard" : "soft"); });
                }
                else {
                    selectedUw = matchingRules[0];
                }
                _this.setState({
                    isHardDecline: selectedUw.declineType === "hard",
                    isErrorDecline: selectedUw.declineType === "error",
                    declineMessage: selectedUw.value
                });
                _this.props.onStateChange("uistate.isHardDecline", selectedUw.declineType === "hard");
            }
        };
        _this.state = {
            isHardDecline: false,
            isErrorDecline: false,
            declineMessage: ""
        };
        return _this;
    }
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-group declineTextWidget", children: [(0, jsx_runtime_1.jsxs)("div", { className: "section-panel", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-center text-blue-1", children: this.state.declineMessage }), this.inRenewalWindow && !this.state.isErrorDecline && this.renderRenewalWindowDeclineText(), !this.inRenewalWindow && !this.state.isErrorDecline && this.renderRenewalQuoteDeclineText()] }), (0, jsx_runtime_1.jsx)("div", { className: "cancel-policy-btn", children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!this.state.isErrorDecline && this.renderCancelPolicyButton(), !this.state.isHardDecline && this.renderCancelChangesButton()] }) })] }));
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.componentDidMount = function () {
        this.renderWording(this.underwritingResultArray[0].objectName);
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.renderRenewalWindowDeclineText = function () {
        if (this.state.isHardDecline) {
            return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center font-weight-semi-bold", children: ["In order to make alternative insurance arrangements your car policy will end ", (0, commonFunctions_1.getHardDeclineEndDateText)(this.props.interaction), " 23:59. Until then you are still covered."] }));
        }
        else {
            var feeWording = this.chargeCancellationFee(this.props.interaction) ? "" : " without a cancellation fee";
            return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center font-weight-semi-bold", children: ["You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel the insurance", feeWording, ". Please note this will also cancel your upcoming renewal."] }));
        }
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.renderRenewalQuoteDeclineText = function () {
        if (this.state.isHardDecline) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "text-center font-weight-semi-bold", children: ["You'll need to make alternative insurance arrangements as your car policy will end on ", (0, commonFunctions_1.formatDate)(this.props.engine.getInteraction().renewalDetails.lastYearsCoverEndDate, "DD MMMM YYYY"), ", 23:59. Until then you are still covered."] }));
        }
        else {
            var feeWording = this.chargeCancellationFee(this.props.interaction) ? "" : " without a cancellation fee";
            return ((0, jsx_runtime_1.jsxs)("div", { className: "text-center font-weight-semi-bold", children: ["You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel your renewal", feeWording, "."] }));
        }
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.cancelPolicy = function () {
        this.props.onStateChange("uistate.mtaDeclineAction", "cancelPolicy");
        this.executeEvent("change");
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.renderCancelPolicyButton = function () {
        if (this.inRenewalWindow) {
            return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/journey/show/product/PropositionWolfMotorInsurance/process/supportPortalAnnualCancellation/presetPage/".concat(this.props.interaction._id), id: "cancelPolicy", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary ".concat(this.state.isHardDecline ? 'btn-back' : '', " btn-next-decline"), children: "Cancel policy" }) }));
        }
        else if (this.state.isHardDecline) {
            return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/journey/show/product/PropositionWolfMotorInsurance/process/mtcForcedSupportPortal/presetPage/".concat(this.props.interaction._id), id: "cancelPolicy", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-back btn-next-decline", children: "Cancel policy" }) }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: this.cancelPolicy, className: "btn btn-primary btn-next-decline", children: "Cancel policy" }));
        }
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.renderCancelChangesButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.interaction.userReference), id: "decline-page-back", children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back", children: "Cancel changes" }) }));
    };
    SupportPortalRenewalMTADeclineTextOutputWidget.prototype.chargeCancellationFee = function (interaction) {
        if (interaction.underwritingResult && interaction.underwritingResult.length > 0) {
            var limitFailures = interaction.underwritingResult.find(function (uw) { return uw.objectName === "UWW060" || uw.objectName === "UWW061" || uw.objectName === "UWW062" || uw.objectName === "UWW063"; });
            return limitFailures;
        }
        return false;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], SupportPortalRenewalMTADeclineTextOutputWidget.prototype, "journeyRuntimeService", void 0);
    return SupportPortalRenewalMTADeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.SupportPortalRenewalMTADeclineTextOutputWidget = SupportPortalRenewalMTADeclineTextOutputWidget;
//# sourceMappingURL=SupportPortalRenewalMTADeclineTextOutputWidget.js.map